
import { CANDIDATE_JOB_PLANNED_REQUEST, CANDIDATE_JOB_PLANNED_SUCCESS, CANDIDATE_JOB_PLANNED_FAIL } from "../constants/AuthConstant"

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};
const CandidateInterviewPlannedReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_JOB_PLANNED_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case CANDIDATE_JOB_PLANNED_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case CANDIDATE_JOB_PLANNED_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default CandidateInterviewPlannedReducer;
